export default __webpack_public_path__ + "static/katerina-2fc879b6b88c604d642281abca79fdc8.jpg";